// Modal Galerie : portraits des fantômes photographiés (nom + niveau), du plus récent au plus
// ancien. Un tap sur un portrait l'affiche en grand (nom, trait de caractère) ; un second tap
// revient à la grille.
import { $, show, hide, escapeHTML } from './dom.js';
import { familyName, familyTrait, familySprite } from '../data/family.js';

/** @param {{ t: (key: string, params?: object) => string, getLanguage: () => string }} deps */
export function createGalleryView({ t, getLanguage }) {
  const modal = $('galleryModal');
  const grid = $('galleryGrid');
  const empty = $('galleryEmpty');
  const detail = $('galleryDetail');
  const detailName = $('galleryDetailName');
  const detailTrait = $('galleryDetailTrait');
  const detailLevel = $('galleryDetailLevel');
  const detailSprite = $('galleryDetailSprite');
  let current = []; // galerie rendue, indexée comme la grille

  /** @param {import('../core/gallery.js').Portrait[]} gallery */
  function render(gallery) {
    current = gallery;
    const lang = getLanguage();
    empty.hidden = gallery.length > 0;
    grid.innerHTML = gallery.map((p, i) => `
      <li class="portrait" data-index="${i}" role="button" tabindex="0" style="--ghost-color:${escapeHTML(p.color)}">
        <img src="${escapeHTML(familySprite(p.familyIndex))}" alt="" class="portrait-sprite">
        <span class="portrait-name">${escapeHTML(familyName(lang, p.familyIndex))}</span>
      </li>`).join('');
  }

  function showDetail(portrait) {
    const lang = getLanguage();
    detail.style.setProperty('--ghost-color', portrait.color);
    detailName.innerText = familyName(lang, portrait.familyIndex);
    detailName.style.color = portrait.color;
    detailTrait.innerText = familyTrait(lang, portrait.familyIndex);
    detailLevel.innerText = t('gallery.level', { level: portrait.level });
    detailSprite.src = familySprite(portrait.familyIndex);
    detailSprite.style.filter = `drop-shadow(0 0 22px ${portrait.color})`;
    show(detail);
  }

  grid.addEventListener('click', (e) => {
    const li = e.target.closest('.portrait');
    if (!li) return;
    const portrait = current[Number(li.dataset.index)];
    if (portrait) showDetail(portrait);
  });
  grid.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const li = e.target.closest('.portrait');
    if (!li) return;
    e.preventDefault();
    const portrait = current[Number(li.dataset.index)];
    if (portrait) showDetail(portrait);
  });
  detail.addEventListener('click', () => hide(detail)); // re-tap : retour à la grille

  return {
    render,
    open: () => { hide(detail); show(modal); },
    close: () => { hide(detail); hide(modal); },
    btnOpen: $('btnShowGallery'),
    btnClose: $('btnCloseGallery'),
  };
}
